import axios from 'axios';
import { LOCALE_INTL, idiomaActual } from '@/i18n';

const envBase = (import.meta.env.VITE_API_URL as string | undefined)?.trim();

function resolveBaseURL(): string {
    if (envBase && envBase.length > 0) {
        // If the configured API URL points at localhost/127.0.0.1 but the SPA
        // is being served from another host (e.g. a phone on the LAN), rewrite
        // the hostname so the browser reaches the same backend the SPA came from.
        if (typeof window !== 'undefined') {
            try {
                const url = new URL(envBase, window.location.origin);
                const isLocalHost = url.hostname === 'localhost' || url.hostname === '127.0.0.1';
                const browserIsRemote =
                    window.location.hostname !== 'localhost' && window.location.hostname !== '127.0.0.1';
                if (isLocalHost && browserIsRemote) {
                    url.hostname = window.location.hostname;
                }
                return url.toString().replace(/\/$/, '');
            } catch {
                return envBase;
            }
        }
        return envBase;
    }
    if (typeof window !== 'undefined') {
        return `${window.location.protocol}//${window.location.hostname}:8000/api/v1`;
    }
    return '/api/v1';
}

const client = axios.create({
    baseURL: resolveBaseURL(),
    headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
    },
});

client.interceptors.request.use((config) => {
    const token = localStorage.getItem('metrosafe_token') ?? localStorage.getItem('token');
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    // El backend traduce sus mensajes con esta cabecera (middleware EstablecerIdioma).
    // Se lee el idioma activo de módulo y no el del navegador: lo que manda es el
    // selector de Configuración, que es lo que el operador ve en pantalla.
    const idioma = idiomaActual();
    config.headers['Accept-Language'] = `${LOCALE_INTL[idioma]},${idioma};q=0.9`;
    return config;
});

client.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response?.status === 401) {
            localStorage.removeItem('metrosafe_token');
            localStorage.removeItem('token');
            localStorage.removeItem('user');
            localStorage.removeItem('metrosafe_user');
            if (!window.location.pathname.startsWith('/login')) {
                window.location.href = '/login';
            }
        }
        return Promise.reject(error);
    },
);

export default client;
